import React from 'react';
import { Link } from 'react-router-dom';
import MkIcon from '../MkIcon';
import { SUPPORT_EMAIL } from '../../../marketing/links';
import { mkTrack } from '../../../marketing/track';

const [EMAIL_USER, EMAIL_DOMAIN] = SUPPORT_EMAIL.split('@');

const CARDS = [
  {
    icon: 'pin',
    title: 'Location stays on your phone',
    body: "Keep Me Out's Location Locks use your location only on your device — it's never uploaded or shared.",
  },
  {
    icon: 'shield',
    title: 'No data shared with third parties',
    body: "That's what Keep Me Out's Data safety section on Google Play states.",
  },
  {
    icon: 'globe',
    bmb: true,
    title: 'Bring Me Back filters on your phone',
    body: 'Its website filter runs on the device. No browsing data, domains or DNS lookups are sent to a server.',
  },
  {
    icon: 'bell',
    title: 'Made in Berlin. We reply.',
    body: (
      <>
        Keep Me Out is developed by eudaiTec GmbH in Berlin. We reply to reviews on Google Play, and you can write to us
        at{' '}
        <a
          className="mk-inlink"
          href={`mailto:${SUPPORT_EMAIL}`}
          onClick={() => mkTrack('outbound_click', 'support_email:home_trust')}
        >
          {EMAIL_USER}@
          <wbr />
          {EMAIL_DOMAIN}
        </a>
        .
      </>
    ),
  },
];

// H9 — who makes this and what happens to your data: sourced, scoped statements only.
const HomeTrust = () => (
  <section className="mk-trust section" id="trust" aria-labelledby="mk-trust-title">
    <div className="container">
      <div className="section-inner">
        <div className="mk-head reveal-from-bottom">
          <p className="mk-eyebrow">Trust</p>
          <h2 id="mk-trust-title" className="mk-h2">
            Clear about your data.
          </h2>
        </div>
        <ul className="list-reset mk-trust__grid">
          {CARDS.map((c, i) => (
            <li
              key={c.title}
              className="reveal-from-bottom"
              data-reveal-container=".mk-trust__grid"
              data-reveal-delay={i * 80}
            >
              <div className="mk-card mk-trust__card">
                <span className={c.bmb ? 'mk-icon-tile mk-icon-tile--bmb' : 'mk-icon-tile'}>
                  <MkIcon name={c.icon} />
                </span>
                <h3 className="mk-h3">{c.title}</h3>
                <p className="mk-body">{c.body}</p>
              </div>
            </li>
          ))}
        </ul>
        <p className="mk-trust__links">
          <Link className="mk-textlink" to="/Privacy" onClick={() => mkTrack('nav_click', 'privacy:home_trust')}>
            Read the Keep Me Out privacy policy →
          </Link>
          <span className="mk-trust__sep" aria-hidden="true">
            ·
          </span>
          <Link className="mk-textlink" to="/Help" onClick={() => mkTrack('nav_click', 'help:home_trust')}>
            Get help →
          </Link>
        </p>
      </div>
    </div>
  </section>
);

export default HomeTrust;
